import { IComparisonToastPayload } from '../types/comparisonToast';
import { IApplicationState } from '../types/redux';

export function selectComparisonToast(state: IApplicationState): IComparisonToastPayload | null {
  return state.comparisonToast.toast;
}
